module.exports = __webpack_public_path__ + "img/TFF_StackedLogo_BIL.dc58ddf3.png";